var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    viewBox: "25.51 25.51 48.97 48.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,25.514c-13.502,0-24.486,10.985-24.486,24.486c0,13.502,10.984,24.487,24.486,24.487S74.486,63.502,74.486,50  C74.486,36.498,63.502,25.514,50,25.514z M50,71.486c-11.848,0-21.486-9.639-21.486-21.487S38.152,28.514,50,28.514  S71.486,38.152,71.486,50C71.486,61.848,61.848,71.486,50,71.486z M47.645,64.113h4.711v-4.537h-4.711V64.113z M47.645,54.594h4.711  V35.887h-4.711V54.594z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.6b803115d7152719d3153313d5345647.svg";
export { ForwardRef as ReactComponent };